import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import ReactDOM from "react-dom/client";
import { PageLayout, theme } from "@sista/dista-ui";
import { ThemeProvider } from "@mui/material/styles";
import { login } from "@sista/idm-client";
import { i18nextConfigure } from "@sista/fe-commons";
import { LicenseInfo } from "@mui/x-license";
import App from "./App";
import "./i18n";
LicenseInfo.setLicenseKey(process.env.MUI_X_LICENSE_KEY || "");
i18nextConfigure({
    currentAppNamespace: "sprava-textu",
    debug: false, // process.env.NODE_ENV === "development",
});
// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(_jsx(ThemeProvider, { theme: theme, children: _jsx(PageLayout, { sidebarOpen: false, mainMenuProps: { menuItems: [] }, children: "" }) }));
login({
    idmRoot: process.env.REACT_APP_IDM_ROOT || "/idm",
    ucetRoot: process.env.REACT_APP_UCET_ROOT || "/ucet",
    clientId: process.env.REACT_APP_CLIENT_ID || "demo",
    useLocalStorageLogin: true,
    useIframeLogin: true,
    useLoginWindowLogin: false,
}).then((account) => {
    console.debug("Logged account", account);
    root.render(_jsx(React.StrictMode, { children: _jsx(App, { account: account }) }));
});
